import { useState } from "react";
import { cn } from "@/lib/utils";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";

/** Il campo della password con «Mostra» / «Nascondi» (B4-accesso): si vede cosa si è scritto prima di mandarlo. */
export function CampoPassword({ id, value, onChange, autoComplete, testId, invalido, className, ...props }) {
  const [visibile, setVisibile] = useState(false);
  return (
    <div
      className={cn(
        "flex h-11 items-center rounded-md border border-line-input bg-surface pl-3 pr-1 transition-colors duration-150 ease-enter focus-within:border-brand focus-within:ring-1 focus-within:ring-brand max-md:h-[52px]",
        invalido && "border-danger",
        className,
      )}
    >
      <input
        id={id}
        type={visibile ? "text" : "password"}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        data-testid={testId}
        aria-invalid={invalido || undefined}
        className="h-full min-w-0 flex-1 bg-transparent text-body text-ink outline-none placeholder:text-ink-3 max-md:text-base"
        {...props}
      />
      <button
        type="button"
        aria-pressed={visibile}
        aria-label={visibile ? "Nascondi la password" : "Mostra la password"}
        onClick={() => setVisibile((v) => !v)}
        className="h-10 shrink-0 rounded-sm px-3 font-semibold text-brand-ink transition-colors duration-150 ease-enter hover:bg-surface-2 max-md:h-11"
      >
        {visibile ? "Nascondi" : "Mostra"}
      </button>
    </div>
  );
}

/** Le sei cifre del codice di verifica, in sei riquadri separati (B4-codice): 60 × 68 sul computer, 48 × 60 sul telefono. */
export function CodiceSei({ value, onChange, invalido, disabled, ...props }) {
  return (
    <InputOTP
      maxLength={6}
      value={value}
      onChange={onChange}
      disabled={disabled}
      inputMode="numeric"
      autoComplete="one-time-code"
      aria-invalid={invalido || undefined}
      containerClassName="gap-0 w-full sm:w-auto"
      {...props}
    >
      <InputOTPGroup className="w-full justify-between gap-2 sm:w-auto sm:justify-start sm:gap-2.5">
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <InputOTPSlot
            key={i}
            index={i}
            className={cn(
              "h-[60px] w-12 rounded-md border bg-surface font-display text-2xl font-semibold tabular-nums text-ink-strong shadow-none first:rounded-l-md last:rounded-r-md sm:h-[68px] sm:w-[60px] sm:rounded-lg sm:text-[28px] sm:first:rounded-l-lg sm:last:rounded-r-lg",
              invalido ? "border-danger" : "border-line-input",
            )}
          />
        ))}
      </InputOTPGroup>
    </InputOTP>
  );
}
